import React from 'react';

const AuthLayout = ({ children, title, subtitle, wide = false }) => {
  const containerClass = wide ? 'max-w-2xl' : 'max-w-md';
  const cardPadding = wide ? 'p-4 lg:p-5' : 'p-8';
  const headerMargin = wide ? 'mb-4' : 'mb-6';
  const titleSize = wide ? 'text-xl' : 'text-2xl';
  const titleMargin = wide ? 'mb-1' : 'mb-2';
  
  return (
    <div className="min-h-screen bg-bg-secondary flex items-center justify-center px-4 py-2">
      <div className={`${containerClass} w-full`}>
        {/* Auth Card */}
        <div className={`card ${cardPadding}`}>
          <div className={headerMargin}>
            <h2 className={`${titleSize} font-semibold text-text-primary ${titleMargin}`}>{title}</h2>
            {subtitle && (
              <p className="text-text-secondary text-sm">{subtitle}</p>
            )}
          </div>
          
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;